// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XkCXD","badges":"styles_badges__3a7r3"};